import http_request from './http_request'
import config from 'config'

function getOEQ(id, jwt) {
	const headers = {}
	if (jwt) {
		headers.jwt = jwt
	}
	return http_request.get(config.api + 'poll/' + id)
		.withHeaders(headers)
		.send()
}

export default {
	getOEQ,
}
